// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@eisinc/Overrides/Widgets/Brand/BrandGallery";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

listStyles.title = {
    variant: "h3",
};

listStyles.titleViewAll = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;

        .view-all-link {
            font-size: 18px;
            line-height: 30px;
            text-transform: capitalize;
            justify-content: flex-end;

            &,
            &:focus {
                outline: 0;
            }
        }

        h3,
        .view-all-link {
            flex: 1;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;

                        h3 {
                            margin-bottom: 16px;
                        }

                        h3,
                        .view-all-link {
                            width: 100%;
                        }
                    `,
                ],
                "max",
            )}
    `,
};
listStyles.image = {
    css: css`
        aspect-ratio: 164 / 82;
        ${xScreen("lte", "md")} {
            aspect-ratio: 169 / 85;
        }
        ${xScreen("lt", "sm")} {
            aspect-ratio: 156 / 78;
        }
    `,
};

listStyles.link = {
    css: css`
        &,
        &:focus {
            outline: 0;
        }
    `,
};

listStyles.imageContainer = {
    css: css`
        display: grid;
        ${({ mobile, tablet, desktop }: any) => css`
            grid-template-columns: repeat(${desktop}, 1fr);
            column-gap: 31px;
            row-gap: 32px;
            ${xScreen("lte", "md")} {
                grid-template-columns: repeat(${tablet}, 1fr);
                column-gap: 20px;
            }
            ${xScreen("lt", "sm")} {
                grid-template-columns: repeat(${mobile}, 1fr);
                column-gap: 16px;
            }
        `}
    `,
};

listStyles.imageItem = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
